import ParticipantServiceFamily, {IParticipantServiceFamily} from "@/model/ServiceFamily/ParticipantServiceFamily"

export interface ITransportServiceFamily extends IParticipantServiceFamily {

}

class TransportServiceFamily extends ParticipantServiceFamily implements ITransportServiceFamily {
    
    constructor(id: string) {
        super(id)
    }
}

export default TransportServiceFamily